"use strict";
const defaultElementId = "g-recaptcha";
const apiScriptId = "recaptcha-api";
const onloadCallbackName = "fppRecaptchaLoaded";
export const recaptchaLoadErrorMessage = "The CAPTCHA could not load. Please check your connection or allow www.google.com/recaptcha in your content blocker, then refresh the page.";
export class RecaptchaService {
  static getCaptchaResponse(elementId = defaultElementId) {
    const grecaptcha = window.grecaptcha;
    const widgetId = this.widgetIds[elementId];
    if (typeof grecaptcha?.getResponse === "function" && widgetId !== void 0) {
      return grecaptcha.getResponse(widgetId);
    }
    if (elementId !== defaultElementId) {
      return "";
    }
    const element = document.getElementById(
      "g-recaptcha-response"
    );
    return element?.value ?? "";
  }
  static resetCaptcha(elementId = defaultElementId) {
    const grecaptcha = window.grecaptcha;
    const widgetId = this.widgetIds[elementId];
    if (typeof grecaptcha?.reset === "function") {
      grecaptcha.reset(widgetId);
    }
  }
  static initRecaptcha(elementId = defaultElementId) {
    if (!document.getElementById(elementId) || Object.prototype.hasOwnProperty.call(
      this.widgetIds,
      elementId
    )) {
      return;
    }
    if (typeof window.grecaptcha?.render === "function") {
      this.render(elementId);
      return;
    }
    this.pendingElementIds.add(elementId);
    const script = document.getElementById(apiScriptId) ?? this.appendApiScript();
    if (script.hasAttribute("data-failed")) {
      this.showLoadError();
    }
  }
  static render(elementId) {
    const grecaptcha = window.grecaptcha;
    if (!document.getElementById(elementId) || typeof grecaptcha?.render !== "function" || Object.prototype.hasOwnProperty.call(this.widgetIds, elementId)) {
      return;
    }
    this.widgetIds[elementId] = grecaptcha.render(elementId, {
      sitekey: "6LdtbAITAAAAAJ1ew5joky0iZVeNDJY3MQZNmQSU",
      theme: "light"
    });
  }
  static renderPending() {
    this.pendingElementIds.forEach((elementId) => this.render(elementId));
    this.pendingElementIds.clear();
  }
  static showLoadError() {
    this.pendingElementIds.forEach((elementId) => {
      const element = document.getElementById(elementId);
      if (element) {
        element.setAttribute("role", "alert");
        element.textContent = recaptchaLoadErrorMessage;
      }
    });
    this.pendingElementIds.clear();
  }
  static appendApiScript() {
    window[onloadCallbackName] = () => this.renderPending();
    const script = document.createElement("script");
    script.id = apiScriptId;
    script.src = `https://www.google.com/recaptcha/api.js?onload=${onloadCallbackName}&render=explicit`;
    script.async = true;
    script.onerror = () => {
      script.setAttribute("data-failed", "true");
      this.showLoadError();
    };
    document.head.appendChild(script);
    return script;
  }
}
RecaptchaService.widgetIds = {};
RecaptchaService.pendingElementIds = /* @__PURE__ */ new Set();
